import React from 'react';
import { useSelector } from 'react-redux';
import { ConditionValueValue } from 'components/campaigns/models/CampaignItem';
import { MultiSelectSuggest } from 'lib/MultiSelectSuggest';
import { Option } from 'lib/types';
import { ApplicationState } from 'store/store';

interface LocationConditionProps {
    value?: ConditionValueValue;
    onChange: (value: string) => void;
}

export function LocationCondition(props: LocationConditionProps) {
    const { onChange, value } = props;
    const { locations } = useSelector((state: ApplicationState) => state.locations);
    const options = React.useMemo(
        () => locations.map(item => ({ label: item.title, value: item._id })),
        [locations]
    );
    const formattedValue = React.useMemo(() => options.find(item => item.value === value), [value, options]);

    const handleChange = React.useCallback(
        (value: Option) => {
            onChange(value ? value.value : '');
        },
        [onChange]
    );
    return (
        <MultiSelectSuggest
            value={formattedValue || null}
            isMulti={false}
            onChange={handleChange}
            placeholder="Choose a location"
            options={options}
            isCreatable={false}
        />
    );
}
